import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { filter, tap } from 'rxjs/operators';
import { ServerEventService } from '../server-event.service';
import { DrEvent } from '@app/shared/models/server-event.model';
import { MessageData } from '@app/shared/models/message';

export interface MessagingEventData extends DrEvent<MessageData, string> {}

@Injectable({
    providedIn: 'root'
})
export class MessagingWebSocketService extends BaseService {

    public static WebSocketEvents = {
        RECEIVED: 'messages.received'
    };

    private readonly msgPrefix = 'MessagingWebSocketService';

    constructor(private _serverEventService: ServerEventService<MessageData>) {
        super();
    }

    get socket() {
        return this._serverEventService.events.pipe(
            filter((event) => [
                MessagingWebSocketService.WebSocketEvents.RECEIVED,
            ].includes(event.event)),
            
            tap((event) =>
              console.log(`${this.msgPrefix} - processing event: ${event.event}`)
            )
        );
    }
}
